<template>
  <a-layout-header :class="[fixHeader && 'ant-header-fixedHeader', layout === 'side' ? (sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, theme, 'global-header' ]">
    <div :class="['global-header-wide', layout]">
      <router-link v-if="isMobile || layout === 'head'"
                   to="/"
                   :class="['logo', isMobile ? null : 'pc', theme]">
        <img height="32"
             v-if="this.$store.state.setting.theme === 'dark'"
             :src="logoUrlDark"
             alt="" />
        <img height="32"
             v-if="this.$store.state.setting.theme === 'light'"
             :src="logoUrlLight"
             alt="" />
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link>
      <a-divider v-if="isMobile"
                 type="vertical" />
      <a-icon v-if="layout === 'side'"
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="toggleCollapse" />
      <div v-if="layout === 'head'"
           class="global-header-menu">
        <i-menu style="height: 64px; line-height: 64px;"
                class="system-top-menu"
                :theme="theme"
                mode="horizontal"
                :menuData="menuData"
                @select="onSelect" />
      </div>
      <div :class="['global-header-right', theme]">
        <div class="header-item">
          <a-dropdown v-model="noticeCount.noticeVisible"
                      placement="bottomRight">
            <a-badge :count="noticeCount.total"
                     :overflowCount="999"
                     style="height: 15px; line-height: 15px;">
              <a-icon type="read"
                      style="font-size: 1.5em" />
            </a-badge>
            <div slot="overlay"
                 class="notice-dropdown"
                 @click="handleMenuClick">
              <a-menu v-if="noticeCount.total > 0">
                <a-menu-item v-for="item in noticeCount.noticesData"
                             :key="item.noticeId"
                             @click="handleNoticeClick(item)">
                  <span>{{item.noticeTitle}}</span>
                </a-menu-item>
              </a-menu>
              <div class="ant-empty ant-empty-normal"
                   v-else>
                <div class="ant-empty-image">
                  <svg width="64"
                       height="41"
                       viewBox="0 0 64 41"
                       xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(0 1)"
                       fill="none"
                       fillRule="evenodd">
                      <ellipse fill="#F5F5F5"
                               cx="32"
                               cy="33"
                               rx="32"
                               ry="7"></ellipse>
                      <g fillRule="nonzero"
                         stroke="#D9D9D9">
                        <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                        <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                              fill="#FAFAFA"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <p class="ant-empty-description">暂无数据</p>
              </div>
            </div>
          </a-dropdown>
        </div>
        <header-avatar class="header-item" />
      </div>
    </div>
    <a-modal :title="noticeModalTitle"
             :keyboard="false"
             :maskClosable="false"
             :closable="true"
             :footer="null"
             @cancel="() => {noticeModal.modalVisiable = false}"
             :visible="noticeModal.modalVisiable"
             :width="920">
      <a-row class="notice-modal-rows">
        <a-col :span="24">
          <pre class="notice-modal-row-content">{{noticeModal.modalData.noticeContent}}</pre>
        </a-col>
      </a-row>
    </a-modal>
  </a-layout-header>
</template>

<script>
import HeaderAvatar from './HeaderAvatar'
import IMenu from '@/components/menu/menu'
import { mapState } from 'vuex'

export default {
  name: 'GlobalHeader',
  components: { IMenu, HeaderAvatar },
  props: ['collapsed', 'menuData'],
  data () {
    return {
      stompClient: null,
      noticeCount: {
        total: 0,
        noticesData: [],
        noticeVisible: false
      },
      noticeModal: {
        modalData: {},
        modalVisiable: false
      },
      alarmInterval: null,
      notificationCount: 0,
      alarm: {
        alarmTime: '',
        alarmMsg: ''
      },
      index: 0,
      alarmList: [],
      notifiKey: '',
      showInfoFlag: false,
      alarmLevel: null
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.setting.isMobile,
      layout: state => state.setting.layout,
      systemName: state => state.setting.systemName,
      sidebarOpened: state => state.setting.sidebar.opened,
      fixHeader: state => state.setting.fixHeader,
      user: state => state.account.user,
      logoUrlDark: state => state.setting.logoUrlDark,
      logoUrlLight: state => state.setting.logoUrlLight
    }),
    theme () {
      return this.layout === 'side' ? 'light' : this.$store.state.setting.theme
    }
  },
  created () {
    // this.initAlarm()
    // this.alarmInterval = setInterval(() => {
    //   if (this.$route.path.indexOf('iot') !== -1 || this.$route.path.indexOf('home') !== -1) {
    //     this.initAlarm()
    //   } else {
    //     clearInterval(this.alarmInterval)
    //   }
    // }, 60000)
    this.initNotice()
  },
  methods: {
    noticeModalTitle (h) {
      let noticeType = this.noticeModal.modalData.noticeType === '1' ? '通知' : '公告'
      return h('div', {}, [
        h('a-tag', { 'class': 'ant-tag-cyan' }, [noticeType]),
        h('span', '  ' + this.noticeModal.modalData.noticeTitle)
      ])
    },
    toggleCollapse () {
      this.$emit('toggleCollapse')
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    },
    openAlarmNotification (obj) {
      let iconType = null
      let iconStyle = ''
      switch (obj.level) {
        case '1':
          iconType = 'close-circle'
          iconStyle = '#ff2f96'
          break
        case '2':
          iconType = 'warning'
          iconStyle = '#faad14'
          break
        case '3':
          iconType = 'warning'
          iconStyle = '#1890ff'
          break
        default:
          iconType = 'exclamation-circle'
          iconStyle = '#1890ff'
          break
      }
      this.$notification.open({
        placement: 'bottomRight',
        message: obj.device + ' - ' + obj.type,
        description: obj.message,
        icon: h => {
          return h(
            'a-icon',
            {
              props: {
                type: iconType,
                theme: 'twoTone',
                twoToneColor: iconStyle
              }
            }
          )
        }
      })
    },
    handleMenuClick (e) {
      if (e.key) {
        this.noticeCount.noticeVisible = false
      } else {
        this.noticeCount.noticeVisible = true
      }
    },
    initNotice () {
      this.noticeCount = {
        total: 0,
        noticesData: [],
        noticeVisible: false
      }
      this.$post('admin/system/notice/query').then((r) => {
        this.noticeCount.total = r.data.total
        this.noticeCount.noticesData = r.data.rows
      }).catch(() => {
        console.log('获取通知公告失败')
      })
    },
    // initAlarm () {
    //   this.$post('auth/home/alarm/count/notprocess').then((r) => {
    //     this.alarmCount.totalUnprocess = r.data
    //   }).catch(() => {
    //     this.alarmCount = 0
    //     console.log('获取报警数量失败')
    //   })
    // },
    handleNoticeClick (notice) {
      this.noticeModal.modalData = notice
      this.noticeModal.modalVisiable = true
    },
    getAlarmLevelText (text) {
      switch (text) {
        case '1': return '紧急'
        case '2': return '重要'
        case '3': return '次要'
        case '4': return '提示'
        default: return text
      }
    }
  }
}
</script>

<style lang="less" scoped>
.trigger {
  font-size: 20px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
.header-item {
  padding: 0 19px;
  display: inline-block;
  height: 100%;
  cursor: pointer;
  vertical-align: middle;
  i {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
  }
}
.global-header {
  padding: 0 12px 0 0;
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  &.light {
    background: #fff;
  }
  &.dark {
    background: #393e46;
  }
  .global-header-wide {
    &.head {
      padding: 0 24px;
    }
    .logo {
      height: 64px;
      line-height: 58px;
      vertical-align: top;
      display: inline-block;
      padding: 0 12px 0 24px;
      cursor: pointer;
      font-size: 20px;
      &.pc {
        padding: 0 12px 0 0;
      }
      img {
        display: inline-block;
        vertical-align: middle;
      }
      h1 {
        display: inline-block;
        font-size: 16px;
      }
      &.dark h1 {
        color: #fff;
      }
    }
    .global-header-menu {
      display: inline-block;
    }
    .global-header-right {
      float: right;
      &.dark {
        color: #fff;
        i {
          color: #fff;
        }
      }
    }
  }
}
.ant-header-fixedHeader {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  transition: width 0.2s;

  &.ant-header-side-opened {
    width: 100%;
    padding-left: 254px;
  }

  &.ant-header-side-closed {
    width: 100%;
    padding-left: 80px;
  }
}
.notice-dropdown {
  width: 280px;
  margin-top: 26px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  /deep/ .ant-tabs-bar {
    margin-bottom: 0px;
    /deep/ .ant-tabs-nav-scroll {
      text-align: center;
    }
  }
  /deep/ .ant-tabs-content {
    max-height: 150px;
    min-height: 120px;
    overflow-y: auto;
    .ant-menu-item {
      margin-bottom: 0px;
      &:not(:last-child) {
        width: 280px;
        border-bottom: 1px solid #e8e8e8;
      }
    }
    .ant-empty {
      position: absolute;
      width: 100%;
      height: 100%;
      text-align: center;
    }
  }
}
.notice-modal-rows {
  &:first-child {
    margin-top: -1em;
  }
  .notice-modal-row-content {
    max-height: 350px;
    line-height: 1.2;
  }
}
</style>
<style lang="less">
/deep/ .ant-notification-notice-description {
  margin-left: 40px !important;
}
.nfs-notification-detail {
  margin-right: 10px;
  font-size: 12px;
}
.nfs-notification-ignore {
  margin-right: 10px;
  font-size: 12px;
  &:hover {
    color: lightgrey;
  }
}
.nfs-notification-button-span {
  margin-right: 8px;
}
.nfs-notification-icon-up {
  position: absolute;
  top: 3px;
  right: 2px;
  font-size: 10px;
}
.nfs-notification-icon-down {
  position: absolute;
  bottom: 1px;
  right: 2px;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// GlobalHeader.vue?2fbac0a6